import type { JSX } from 'react';

/**
 * One floating reaction on the video stage: the emoji, its horizontal start position (percent
 * of the stage width, varied per reaction so simultaneous ones do not stack on one line), and
 * the unique key used to remove it when the animation ends.
 */
export interface ReactionFloater {
  readonly id: number;
  readonly emoji: string;
  readonly leftPct: number;
}

/** Lifetime of one floater; must match the CSS animation duration (index.css). */
export const REACTION_FLOAT_MS = 2500;

/**
 * The overlay above the video stage where incoming reactions drift upward and fade. Purely
 * presentational: the parent owns the floater list and its timers.
 */
export function ReactionOverlay({
  floaters,
}: {
  readonly floaters: readonly ReactionFloater[];
}): JSX.Element {
  return (
    <div
      data-testid="reaction-overlay"
      aria-hidden
      className="pointer-events-none absolute inset-0 z-20 overflow-hidden"
    >
      {floaters.map((floater) => (
        <span
          key={floater.id}
          data-testid={`reaction-${floater.emoji}`}
          className="reaction-floater"
          style={{ left: `${floater.leftPct}%` }}
        >
          {floater.emoji}
        </span>
      ))}
    </div>
  );
}
